import React from 'react';
import GenericCadastroPage from './GenericCadastroPage';

export default function SituacaoProcessoPage() {
  const columns = [
    { key: 'descricao', label: 'Descrição' },
  ];

  const fields = [
    { name: 'descricao', label: 'Descrição', required: true },
  ];

  return (
    <GenericCadastroPage
      title="Situações de Processo"
      description="Gerencie os status e situações possíveis de um processo."
      tableName="situacao_processo_v2"
      columns={columns}
      fields={fields}
    />
  );
}